export default __webpack_public_path__ + "static/media/logo1.c6319829.png";